export const kilogram = [
  {
    label: '体重',
    key: 'weight',
    value: true,
  },
  {
    label: '除脂肪体重',
    key: 'lean_body_weight',
    value: false,
  },
  {
    label: '総筋肉量',
    key: 'muscle_mass',
    value: false,
  },
  {
    label: '骨量',
    key: 'bone_mass',
    value: false,
  },
]

export const percent = [
  {
    label: '体脂肪率',
    key: 'body_fat_rate',
    value: true,
  },
  {
    label: '皮下脂肪',
    key: 'subcutaneous_fat',
    value: false,
  },
  {
    label: '体水分率',
    key: 'body_water_rate',
    value: false,
  },
  {
    label: '骨格筋',
    key: 'muscle_rate',
    value: false,
  },
  {
    label: 'タンパク質',
    key: 'protein',
    value: false,
  },
]
